import "./style.css";

import iiFeri from "../../assets/II.png";
import ots from "../../assets/OTS.png";
import linkedIn from "../../assets/Linkedin.png";
import facebook from "../../assets/Facebook.png";

export default function SocialIcons() {
  return (
    <div className="social-icons-container">
      <a
        href="https://ii.feri.um.si/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon-container">
          <div className="icon-img">
            <img src={iiFeri} alt="II FERI" />
          </div>
          <div className="icon-text">II FERI</div>
        </div>
      </a>
      <a href="https://www.ots.si/" target="_blank" rel="noopener noreferrer">
        <div className="icon-container">
          <div className="icon-img">
            <img src={ots} alt="OTS 2026" />
          </div>
          <div className="icon-text">OTS 2026</div>
        </div>
      </a>
      <a
        href="https://www.linkedin.com/company/konferenca-ots/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon-container">
          <div className="icon-img">
            <img src={linkedIn} alt="LinkedIn" />
          </div>
          <div className="icon-text">LinkedIn</div>
        </div>
      </a>
      <a
        href="https://www.facebook.com/konferencaOTS"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon-container">
          <div className="icon-img">
            <img src={facebook} alt="Facebook" />
          </div>
          <div className="icon-text">Facebook</div>
        </div>
      </a>
    </div>
  );
}
